import './Markets.css';

import markets from "../../lib/markets.json";

function Markets({ color }) {
  const futureEvents = markets.filter(e => new Date(e.date_start) > new Date());
  const pastEvents = markets.filter(e => new Date(e.date_start) < new Date());

  return (
    <div className={`markets page-container container bg bg-image-${color}`}>
      <h1 id="markets" className={`text-color-${color}`}>Markets</h1>
      <span className={`text-color-${color} market-background-name`}>Markets</span>
      <div className="events events-upcoming section">
        <h2 className={`text-color-${color}`}>Upcoming Events</h2>
        {futureEvents.length ? (
          futureEvents.map((event) => {
          return (
            <div className="market-future" key={event.name + event.date_start}>
              {event.name}
            </div>
          )
        })
        ) : (
          'Check back soon for more events!'
        )}
      </div>
      <div className="events events-upcoming section">
        <h2 className={`text-color-${color}`}>Past Events</h2>
        {pastEvents.map((event) => {
          return (
            <div key={event.name + event.date_start} className="market-past">
              <h3>
                {event.name}
              </h3>
              <p>
                {event.date_start}
              </p>
            </div>
          )
        })}
      </div>
    </div>
  );
}

export default Markets;
